import React from 'react';
import { isAfter } from 'date-fns';
import { Tooltip } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Page } from '@tassomutuo-backoffice/types';

import configEnv from '../../../../config/config';

interface IProps {
  page: Page;
  prodPages: Page[] | undefined;
}

const PageTableStatusTassoRenderCell = ({ page, prodPages }: IProps) => {
  const pageDataInProd = prodPages?.find((p) => p.id === page.id);

  if (!configEnv.isStage) {
    return <CheckCircleIcon color="success" />;
  }

  if (!pageDataInProd) {
    return (
      <Tooltip title="Pagina NON in produzione">
        <ReportIcon color="error" />
      </Tooltip>
    );
  }

  if (isAfter(new Date(page?.updatedAt), new Date(pageDataInProd?.updatedAt))) {
    return (
      <Tooltip title="Produzione non aggiornata">
        <WarningIcon color="warning" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Produzione sincronizzata">
      <CheckCircleIcon color="success" />
    </Tooltip>
  );
};

export default PageTableStatusTassoRenderCell;
